export default "__VITE_ASSET__d5d38818__"